import styled, { css } from 'styled-components'
import { tokens, IconButton } from '@arvoreeducacao/bonsai-ds'
import {
  LoadingTrack,
  TimeStamp
} from '../player-controls/PlayerControls.styles'

export const CommandButton = styled(IconButton).attrs(props => ({
  iconName: props.iconName,
  iconColor: props.iconColor,
  iconSize: 20,
  ghost: true,
  disabled: props.disabled || false
}))`
  background-color: transparent;
  ${props => `
    visibility: ${props.hidden ? 'hidden' : 'visible'}
  `};
`

export const ProgressBar = styled.div<{ value?: number }>`
  position: absolute;
  top: 0;
  width: 100%;
  height: 2px;
  background-image: ${({ value = 10 }) =>
    css`linear-gradient(to right, ${tokens.colors.primary} 0%, ${tokens.colors.primary} ${value}%, ${tokens.colors.black2} ${value}%, ${tokens.colors.black2} 100%);`};
`

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 7px;
  padding-left: 11px;
`

export const CurrentTimeStap = styled(TimeStamp)`
  padding: 0;
  color: ${tokens.colors.black4};
  line-height: 16px;
  font-size: 13px;
`

export const TimeLoading = styled(LoadingTrack)`
  padding: 0;
  color: ${tokens.colors.black4};
  line-height: 16px;
  font-size: 13px;
`

export const BookThumb = styled.img`
  height: 30px;
  margin: 8px;
  border-radius: 3px;
`

export const BookTitle = styled.span`
  color: ${tokens.colors.black4};
  line-height: 16px;
  font-size: 13px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 16px;
`

export const Div = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: calc(100% - 54px);
`

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  flex: 1;
`

export const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  bottom: 48px;
  width: 100%;
  min-height: 48px;
  background-color: ${tokens.colors.white};
  filter: drop-shadow(${tokens.shadows.upSmall});
  z-index: 12;
`
